import type { LiveClip } from "../api/live";
import { metricNum } from "../api/live";
import type { ClipNumbers } from "./clips";

/** Describe published measurements only; this is not an inferred account of the action. */
export function deliverySummary(label: string, numbers: ClipNumbers, bowler?: string | null, batsman?: string | null): string {
  const parts = [label];
  if (bowler) parts.push(`Bowler: ${bowler}`);
  if (batsman) parts.push(`Batter: ${batsman}`);
  if (numbers.locked) return `${parts.join(". ")}. Measurements are locked.`;
  const valid = (n: number | null) => n != null && Number.isFinite(n) && n >= 0;
  if (valid(numbers.speed)) parts.push(`Estimated bowling speed: ${numbers.speed} kilometres per hour`);
  if (valid(numbers.batSpeed)) parts.push(`Estimated bat speed: ${numbers.batSpeed} kilometres per hour`);
  if (valid(numbers.impactSpeed)) parts.push(`Estimated ball speed off the bat: ${numbers.impactSpeed} kilometres per hour`);
  if (valid(numbers.lengthM) && numbers.length !== "full toss") parts.push(`Estimated bounce: ${numbers.lengthM} metres from the batting stumps`);
  if (numbers.length) parts.push(`Estimated length: ${numbers.length}`);
  if (numbers.line) parts.push(`Estimated line: ${numbers.line}`);
  return `${parts.join(". ")}.`;
}

export function liveDeliverySummary(clip: LiveClip): string {
  const word = (id: "length_class" | "line_class") => {
    const m = clip.metrics[id];
    return m?.status === "ok" && typeof m.value === "string" ? m.value.replaceAll("_", " ") : null;
  };
  return deliverySummary(`Clip ${clip.index}`, {
    locked: false, speed: metricNum(clip.metrics.bowl_speed) ?? metricNum(clip.metrics.ball_speed_estimate),
    speedNote: null, batSpeed: metricNum(clip.metrics.bat_swing_speed), impactSpeed: metricNum(clip.metrics.ball_impact_speed),
    lengthM: metricNum(clip.metrics.bounce_length_m, 1), length: word("length_class"), line: word("line_class"),
  }, clip.bowler?.label, clip.batsman?.label);
}
